/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */
import axios from "axios";
import { Message } from "antd";
import { AppSecret } from "../../config";
import { guid } from "../getUuid";
import { MD5 } from "crypto-js";
const service = axios.create({
    baseURL: undefined, // url = base url + request url
    timeout: 35000 // request timeout
})

// request interceptor
service.interceptors.request.use(

    async config => {
        // console.log('cpmfog', config)

        //封装请求头
        // ip访问接口 https://api.ipify.org/?format=json&callback=getip
        // const { data: res } = await axios.get('https://api.ipify.org/?format=json&callback=getip').catch(err => console.log(err))

        // const { data: res } = await axios.get('/getIp/?format=json&callback=getip').catch(err => console.log(err))


        let Authorization = sessionStorage.getItem('token') || '';
        let Z_timestamp = new Date().getTime()
        let Z_nonce = guid()
        let ip = sessionStorage.getItem('ip') || ''
        let Z_signature = MD5(Authorization + AppSecret + Z_timestamp + Z_nonce).toString()
        config.headers = {
            Z_signature,
            Z_nonce,
            Z_timestamp,
            ip,
            // 拦截请求的请求头格式
            'Content-Type': config.headers['Content-Type'] || 'application/x-www-form-urlencoded'
        }
        // getToken接口不加Authorization字段
        if (!config.url.includes('getToken')) config.headers.Authorization = Authorization
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        console.log('resinter', res)
        return res
    },
    err => {

        console.log('err' + err) // for debug
        Message.error('获取失败 ' + err)
        return Promise.reject(err)
    }
)

export default service
